var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trebuchet mt-5"},[(!_vm.juniorId)?_c('div',{staticClass:"row m-2 green"},[_c('h3',[_vm._v("Thank you for registration for this course, we will notify you by email about further instructions.")])]):_vm._e(),_vm._v(" "),(_vm.juniorId)?_c('div',{staticClass:"row m-2 green"},[_c('h3',[_vm._v("Thank you. Registration for course is completed. Junior will get further instructions via email.")])]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aeede32","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./src/components/user/courses/course-details/thank-you-page/thank-you-page.html
// module id = null
// module chunks = 